import { PLACES_AUTOCOMPLETE_ACTION, PLACES_AUTOCOMPLETE_SUCCESS, PLACES_AUTOCOMPLETE_ERROR, PLACES_AUTOCOMPLETE_CLEAR, PLACES_GEOLOCATION_ACTION, PLACES_GEOLOCATION_SUCCESS, PLACES_GEOLOCATION_ERROR, PLACES_REVERSE_GEOCODE_SUCCESS, PLACES_REVERSE_GEOCODE_FAILURE, RESET_AUTOCOMPLETE, PLACES_REVERSE_GEOCODE_ACTION, REORDER_UPDATE_DELIVERY, } from '../../constants';
const initialState = {
    isLoading: false,
    isPlacesGeoLoading: false,
    isPlacesReverseGeoLoading: false,
    deliveryAddress: null,
};
const placesAutocompleteReducer = (state = initialState, action) => {
    switch (action.type) {
        case PLACES_AUTOCOMPLETE_ACTION:
            return {
                ...state,
                isLoading: true,
            };
        case PLACES_AUTOCOMPLETE_SUCCESS:
            return {
                ...state,
                suggestions: action.response.predictions,
                placesAutocompleteError: false,
                isLoading: false,
            };
        case PLACES_AUTOCOMPLETE_ERROR:
            return {
                ...state,
                placesAutocompleteError: true,
                isLoading: false,
            };
        case PLACES_AUTOCOMPLETE_CLEAR:
            return {
                ...state,
                suggestions: [],
                placesAutocompleteError: false,
            };
        case PLACES_GEOLOCATION_ACTION:
            return {
                ...state,
                isPlacesGeoLoading: true,
            };
        case PLACES_GEOLOCATION_SUCCESS:
            return {
                ...state,
                geolocationResult: action.response.results,
                placesAutocompleteError: false,
                isPlacesGeoLoading: false,
                response: [],
                deliveryAddress: action?.deliveryAddress,
            };
        case PLACES_GEOLOCATION_ERROR:
            return {
                ...state,
                isPlacesGeoLoading: false,
            };
        case PLACES_REVERSE_GEOCODE_ACTION: {
            return {
                ...state,
                isPlacesReverseGeoLoading: true,
                response: [],
            };
        }
        case PLACES_REVERSE_GEOCODE_FAILURE:
            return {
                ...state,
                placesAutocompleteError: true,
                isPlacesReverseGeoLoading: false,
                response: [],
            };
        case PLACES_REVERSE_GEOCODE_SUCCESS:
            return {
                ...state,
                placesAutocompleteError: false,
                response: action.response.results,
                isPlacesReverseGeoLoading: false,
                geolocationResult: [],
                deliveryAddress: action?.deliveryAddress,
            };
        case RESET_AUTOCOMPLETE:
            return {
                ...state,
                suggestions: [],
                placesAutocompleteError: false,
                response: [],
                geolocationResult: [],
            };
        case REORDER_UPDATE_DELIVERY:
            return {
                ...state,
                deliveryAddress: action.payload.deliveryAddress,
            };
        default:
            return state;
    }
};
export default placesAutocompleteReducer;
